import React from 'react'
import ViewMaster from '../../Components/ViewMaster/ViewMaster'

function GameList() {
  return (
    <div>GameList</div>
  )
}

export default ViewMaster(GameList)